/**
 * Created by jacmai on 3/27/2017.
 */
define([
  "marionette",
  "messaging/messenger",
  "./apiResponseView",
  "./apiResponseSelector/apiResponseSelectorModule",
], function (Marionette, Messenger, ApiResponseView, ApiResponseSelectorModule) {
  var ApiResponseController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "apiresponse";
      this.region = options.region;
    },
    show: function (apiRequestItem) {
      this.actionItem = apiRequestItem;
      this.layout = new ApiResponseView.apiResponseLayout();
      this.selector = this.addSubModule(
        new ApiResponseSelectorModule({ region: this.layout.selector }),
      );
      this.layout.on(
        "show",
        function () {
          this.selector.show(apiRequestItem);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    getActionItem: function () {
      return this.actionItem;
    },
    isValid: function (callback, context) {
      //No validation needed
      callback.apply(context);
    },
  });

  return ApiResponseController;
});
